<template>
 <div class="background-grey">
   <vue-element-loading :active="loading" :is-full-screen="true"/>
  </div>
</template>

<script>
import {HTTPTICKET,HTTPMentor} from "@/axios.js";
import axios from "axios";
import Swal from 'sweetalert2'

export default {
  data () {
    return {
      loading:false,
      token:this.$route.params.tokenmentor,
    }
  },
  methods:{
      async signout(){
        this.$store.commit("clearlogin");
        window.localStorage.removeItem("ticket");
        console.log('clear')
      },
      async checktokenticket(){
        // await this.signout()
        this.loading = true
        var jwt = require('jsonwebtoken');
        var secret = 'dFvsdd125ssE'
    
        var decoded = jwt.verify(this.token, secret);
         console.log('decoded',decoded, secret)

        this.$store.commit('setUser',decoded.obj)
        let data ={
          key:'token',
          value:decoded.token
        }
        this.$store.commit('updateUser',data)
      }
  },
  async mounted(){
      await this.checktokenticket()
      this.$router.push('/profile')
  },
}
</script>
